import { createWithI18n } from '@post-office/message-maker-browser/i18n';

import { messagesLoader as marketplace } from '@post-office/team-package--i18n--marketplace';
import { type AnyProps } from '@post-office/message-maker-browser/types';
import { type ComponentType } from 'react';

export const withI18n: <T extends AnyProps>(component: ComponentType<T>) => ComponentType<T> =
	createWithI18n(marketplace);
